module.exports = __webpack_public_path__ + "static/media/animate-6.28e27d93.mp4";